module.exports = __webpack_public_path__ + "img/img_wechat_qrcode.e7b4f4b9.svg";